import Modal from "components/common/controls/modal/Modal";
import VerificationCodeProvider, {
  VerificationCodeProviderProps,
} from "fetaures/verification/VerificationCodeProvider";

interface Props {
  onClose: () => void;
  verificationCodeProviderProps: VerificationCodeProviderProps;
}

export default function VerificationCodeProviderPopup(props: Props) {
  const { onClose, verificationCodeProviderProps } = props;

  return (
    <Modal
      visible={true}
      height={"auto"}
      onClose={onClose}
      width="auto"
      displayDefaultActions={false}
    >
      <div className="w-363px">
        <VerificationCodeProvider {...verificationCodeProviderProps} />
      </div>
    </Modal>
  );
}
